import React, { FC, useEffect, useState } from 'react';

import { ExportDishItemsWithIngredientsTarget } from '../../../models/entities/target';
import { Model } from './index.model';

import { useModal } from '../../services/use-modal';
import { MultiTextInput } from 'views/components/multi-text-input';
import { LoadingAnimation } from 'views/components/loading-animation';
import { SecondaryButton } from 'views/components/buttons';
import { Root, Loading, Footer } from './index.styled';

interface Props {
  target: ExportDishItemsWithIngredientsTarget;
}

const ExportDishItemsWithIngredients: FC<Props> = ({ target }) => {

  const modal = useModal();
  const [model, setModel] = useState(new Model({ target }));

  function done() {
    modal.close();
  }

  function watchTarget() {
    let mounted = true;
    model.load().then(it => mounted && setModel(it));
    return () => {
      mounted = false;
    };
  }

  useEffect(watchTarget, []);

  return (
    <Root>
      <h1>Dish Items with Ingredients</h1>
      <fieldset>
        {model.loading ? (
          <Loading>
            <LoadingAnimation />
          </Loading>
        ) : (
          <MultiTextInput value={model.tsv} readOnly={true} height={'480px'} />
        )}
      </fieldset>
      <Footer>
        <SecondaryButton onClick={() => done()}>Done</SecondaryButton>
      </Footer>
    </Root>
  );

};

export { ExportDishItemsWithIngredients };
